var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29709 1.59473C7.29709 1.31858 7.52095 1.09473 7.79709 1.09473H11.0053H11.0056H14.2139C14.49 1.09473 14.7139 1.31858 14.7139 1.59473V2.72322H11.0003H11H7.29709V1.59473ZM15.7139 1.59473V2.72322H21.8075V3.72322H19.9154L18.3901 15.7205C18.2313 16.9692 17.1689 17.9052 15.9101 17.9052H11.1586H11.1581H6.4066C5.1478 17.9052 4.08533 16.9692 3.92657 15.7205L2.40126 3.72322H0.192871V2.72322H6.29709V1.59473C6.29709 0.7663 6.96866 0.0947266 7.79709 0.0947266H11.0053H11.0056H14.2139C15.0423 0.0947266 15.7139 0.7663 15.7139 1.59473ZM3.40931 3.72322L4.91858 15.5944C5.01384 16.3436 5.65132 16.9052 6.4066 16.9052H11.1581H11.1586H15.9101C16.6654 16.9052 17.3028 16.3436 17.3981 15.5944L18.9074 3.72322H11.0003H11H3.40931ZM10.5002 5.81136V14.4042H11.5002V5.81136H10.5002ZM8.09877 14.4042V5.81136H9.09877V14.4042H8.09877ZM12.9016 5.81136V14.4042H13.9016V5.81136H12.9016Z",
    fill: "#FF5A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.5126ee2f430a356e30a6f6063d4f2473.svg";
export { ForwardRef as ReactComponent };